// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"52b6649e","885":"fb3de316"}[chunkId] + ".chunk.js";
};